import { ContactCustomAttribute } from "./conversations";

export interface InvalidImportRow {
    RowId?: string;
    FirstName: string;
    LastName: string;
    Email: string;
    PhoneNumber: string;
    customValues: Record<string, string>;
    Errors: Record<string, string>;
    CustomAttributes: ContactCustomAttribute[];
}

export enum SelectExistingContactAction {
    Fill_Blank_Fields,
    USE_FILEDATA,
    KEEPEXISTINGFALKON
}

export enum SelectGroupAction {
    BOTH,
    ONLY_NEW,
    ONLY_EXISTING
}

export interface ImportedContact {
    FirstName: string;
    LastName: string;
    Email: string;
    PhoneNumber: string;
    CustomAttributes: ContactCustomAttribute[];
}

export type ImportedContactModelWithErrors = ImportedContact & {
    Errors: { columnName: string; errorMessage: string; }[];
};